import { Howl } from "howler";

import bonneReponse from "assets/audio/bonne_reponse.wav";
import mauvaiseReponse from "assets/audio/mauvaise_reponse.wav";
import carteQuiSeRetourne from "assets/audio/carte_qui_se_retourne.wav";
import mouvementDePion from "assets/audio/mouvement_de_pion.wav";
import victoire from "assets/audio/victoire.wav";
import dé from "assets/audio/dé.wav";
import ambiantMusic from "assets/audio/ambiant_music.wav";

class SoundManager {
	static instance = null;

	constructor() {
		if (SoundManager.instance) {
			return SoundManager.instance; // Return existing instance
		}

		this.sounds = {
			ambiantMusic: new Howl({ src: [ambiantMusic], html5: true }),
			correct: new Howl({ src: [bonneReponse], html5: true }),
			error: new Howl({ src: [mauvaiseReponse] }),
			flippingCard: new Howl({ src: [carteQuiSeRetourne] }),
			dice: new Howl({ src: [dé] }),
			pawnMove: new Howl({ src: [mouvementDePion] }),
			victory: new Howl({ src: [victoire] }),
		};

		this.muted = false; // Track mute state globally

		SoundManager.instance = this; // Store the instance
	}

	playSound(soundName, volume = 1) {
		if (!this.muted && this.sounds[soundName]) {
			this.sounds[soundName].volume(volume);
			this.sounds[soundName].play();
		}
	}

	stopSound(soundName) {
		if (this.sounds[soundName]) {
			this.sounds[soundName].stop();
		}
	}

	playLoopSound(soundName, speed = 1) {
		if (this.sounds[soundName] && !this.sounds[soundName].playing()) {
			this.sounds[soundName].rate(speed);
			this.sounds[soundName].loop(true);
			this.sounds[soundName].play();
		}
	}

	stopLoopSound(soundName) {
		if (this.sounds[soundName]) {
			this.sounds[soundName].stop();
		}
	}

	muteAll() {
		this.muted = true;
		for (const sound in this.sounds) {
			this.sounds[sound].mute(true);
		}
	}

	unmuteAll() {
		this.muted = false;
		for (const sound in this.sounds) {
			this.sounds[sound].mute(false);
		}
	}

	isMuted() {
		return this.muted;
	}
}

// Export a single instance of SoundManager
const soundManager = new SoundManager();
export default soundManager;
